/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360RetailerApiContractNfcStickersCreateNfcExportRequest {
    AssignFrom?: Date;
    AssignTo?: Date;
    /**
     * 1 = Product, 2 = InformationCard, 3 = Offer, 4 = CheckOut, 5 = CheckIn
     */
    Type?: Open360RetailerApiContractNfcStickersCreateNfcExportRequest.TypeEnum;
    CategoryIDs?: Array<number>;
    GroupByStores?: boolean;
}
export namespace Open360RetailerApiContractNfcStickersCreateNfcExportRequest {
    export type TypeEnum = 1 | 2 | 3 | 4 | 5;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum,
        NUMBER_3: 3 as TypeEnum,
        NUMBER_4: 4 as TypeEnum,
        NUMBER_5: 5 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360RetailerApiContractNfcStickersCreateNfcExportRequest.ts